import {
    GET_CODE,
    GET_OPENID,
    LOG_OUT,
    ADMIN_USER_LOGIN,
    MOBILE_VALID,
    OPENID_VALID,
    CHECK_LOGIN,
    GIGYA_LOGIN,
} from 'Actions/auth';
// import {setProfile } from 'Utils/jwtUtil'

const initialState = {
    isAuthenticated: '',
};
let payload = {};
let isAuthenticated = false;

export function auth(state = initialState, action) {
    switch (action.type) {
        case GET_CODE:
            payload = action.payload;

            return Object.assign({}, state, {code: payload});
        case GET_OPENID:
            payload = action.payload;

            if (payload && payload.status === 'success') {
                isAuthenticated = 'success';
            }

            return Object.assign({}, state, {isAuthenticated: isAuthenticated});
        case LOG_OUT:
            payload = action.payload;

            return Object.assign({}, state, {
                adminUser: payload,
                isAuthenticated: 'failure',
            });
        case ADMIN_USER_LOGIN:
            payload = action.payload;

            return Object.assign({}, state, {
                adminUser: payload,
                isAuthenticated: 'success',
            });
        case MOBILE_VALID:
            payload = action.payload;

            return Object.assign({}, state, {mobileValid: payload});
        case OPENID_VALID:
            payload = action.payload;

            if (payload && payload.status === 'success') {
                isAuthenticated = 'success';
            }

            return Object.assign({}, state, {isAuthenticated: isAuthenticated});

        case CHECK_LOGIN:
            if (payload) {
                isAuthenticated = 'success';
            } else {
                isAuthenticated = 'failure';
            }

            return Object.assign({}, state, {isAuthenticated: isAuthenticated});
        case GIGYA_LOGIN:
            payload = action.payload;

            if (payload && payload.status === 'success') {
                isAuthenticated = 'success';
            }

            return Object.assign({}, state, {isAuthenticated: isAuthenticated});
        default:
            return state;
    }
}
